import React from "react";
import { cn } from "@/lib/utils";

export default function SectionHeader({ children, className }) {
  return (
    <div className={cn("text-xs uppercase tracking-[0.18em] text-muted-foreground font-bold flex items-center gap-2", className)}>
      {children}
    </div>
  );
}
